import { ChevronLeft, X } from 'lucide-react';
import {
  CloseArrow,
  CloseActionsContainer,
  CloseMenu,
  StyledSubCategory,
  StyledSubCategoryTitle,
  SubcategoryList,
  SubcategoryItem,
} from './styled';
import { useEffect, useRef } from 'react';
import { MenuLinkItem } from 'components/Menu/NewMenu/subcomponents/MenuLinkItem';
import { makeEnvironmentUrl } from 'utils/development-tools';
export const Subcategory = ({ mainLabel, subMenuItems, setSubMenusAreOpen, setIsSubMenuOpen, ...props }) => {
  const submenuRef = useRef(null);

  const closeSubMenu = e => {
    e.preventDefault();
    e.stopPropagation();
    setIsSubMenuOpen(false);
    setSubMenusAreOpen(prevSubMenus => ({
      ...prevSubMenus,
      [mainLabel]: false,
    }));
  };
  useEffect(() => {
    const handleClickOutside = event => {
      if (submenuRef?.current && !submenuRef?.current.contains(event.target)) {
        setIsSubMenuOpen(false);
        return;
      }
    };
    document.addEventListener('click', handleClickOutside);

    return () => document.removeEventListener('click', handleClickOutside);
  }, [setIsSubMenuOpen]);

  return (
    <StyledSubCategory {...props} ref={submenuRef}>
      <CloseActionsContainer onClick={e => closeSubMenu(e)}>
        <CloseArrow>
          <ChevronLeft size={20} />
        </CloseArrow>

        <CloseMenu>
          <X size={20} />
        </CloseMenu>
      </CloseActionsContainer>
      <StyledSubCategoryTitle>{mainLabel}</StyledSubCategoryTitle>

      <SubcategoryList>
        {subMenuItems.map(({ label, link, isExternal, disabled }) => {
          return (
            <SubcategoryItem key={label} disabled={disabled}>
              <MenuLinkItem
                label={label}
                link={makeEnvironmentUrl(link)}
                isExternal={isExternal}
                isChildren={true}
                disabled={disabled}
              />
            </SubcategoryItem>
          );
        })}
      </SubcategoryList>
    </StyledSubCategory>
  );
};
